module.exports = __webpack_public_path__ + "static/media/1009385.0e8f7ff5.png";